<template>
    <v-form ref="form">
        <v-row class="mt-4">
            <v-col cols="4" class="py-0">
                <v-select
                    label="Exposição"
                    class="input-cinza"
                    outlined
                    dense
                    v-model="value.isExposicao"
                    :items="[
                        { text: 'SIM', value: true },
                        { text: 'NÃO', value: false }
                    ]"
                    :disabled="value.fnEditar || value.fnReplicar"
                    :menu-props="menuProps"
                    @change="exposicaoChange()"
                    required
                ></v-select>
            </v-col>
            <v-col cols="4" class="py-0">
                <v-select
                    label="Telas"
                    class="input-cinza"
                    outlined
                    dense
                    v-model="value.isTelaSemana"
                    :items="[
                        { text: 'SIM', value: true },
                        { text: 'NÃO', value: false }
                    ]"
                    :disabled="value.fnEditar || value.fnReplicar"
                    :menu-props="menuProps"
                    @change="telaSemanaChange()"
                    required
                ></v-select>
            </v-col>
            <v-col cols="4" class="py-0" v-if="value.isTelaSemana">
                        <SelectInput
                            label="Semana"
                            class="input-cinza"
                            :menu-props="menuProps"
                            :rules="regra.telas_semanas"
                            outlined
                            dense
                            @change="limpaFiliais()"
                            multiple
                            v-model="value.telas_semanas"
                            :disabled="value.fnEditar"
                            required
                            :items="listaSemanas"
                            :readonly="value.fnEditar"
                            :show-select-all="true"
                            :autocomplete="false"
                        />
            </v-col>
        </v-row>
        <v-row class="mt-4"> 
            <v-col cols="4" class="py-0">
                <v-select
                    label="Negociação Comercial"
                    class="input-cinza"
                    outlined
                    dense
                    v-model="value.negociacao_comercial"
                    :items="['SIM','NÃO']"
                    :disabled="value.fnEditar || value.fnReplicar"
                    :menu-props="menuProps"
                    @change="negociacaoChange()"
                    required
                ></v-select>
            </v-col>
            <v-col cols="4" class="py-0">
                <MesInput
                    label="Período Inicial"
                    v-model="value.mesInicial"
                    :rules="regra.mesInicial"
                    :change="periodoInicialChange"
                    :min="mesAtual"
                    :disabled="bloqueiaPeriodoAcordo"
                    required
                ></MesInput>
            </v-col>
            <v-col cols="4" class="py-0">
                <MesInput
                    label="Período Final"
                    v-model="value.mesFinal"
                    :rules="regra.mesFinal"
                    :change="periodoFinalChange"
                    :min="mesAtual"
                    :disabled="bloqueiaPeriodoAcordo"
                    required
                ></MesInput>
            </v-col>
        </v-row>            
        <v-row >    
            <v-col cols="4" class="py-0">
                <v-autocomplete
                    label="Produto"
                    outlined
                    class="input-cinza"
                    dense
                    v-model="id_produtoBusca"
                    :items="lista.produto"
                    :search-input.sync="buscaProdutoFornecedor"
                    :loading="isLoadingProduto"
                    @change="produtoChange()"
                    :disabled="value.fnEditar"
                    :menu-props="menuProps"
                    clearable
                >
                    <template v-slot:no-data>
                        <p
                            v-if="
                                !buscaProdutoFornecedor ||
                                (buscaProdutoFornecedor &&
                                    buscaProdutoFornecedor.length <= 4)
                            "
                            class="ml-4 mt-4"
                        >
                            Insira pelo menos 4 caracteres para listar os
                            produtos.
                        </p>
                        <p v-else-if="isLoadingProduto" class="ml-4 mt-4">
                            Buscando produtos...
                        </p>
                        <p v-else class="ml-4 mt-4">Nada encontrado</p>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="4" class="py-0">
                <v-text-field
                    label="Fornecedor"
                    class="input-cinza"
                    v-model="value.fornecedor"
                    :rules="regra.fornecedor"
                    :disabled="value.fnEditar || value.fnReplicar"
                    outlined
                    dense
                    readonly
                    required
                ></v-text-field>
            </v-col>
			<v-col cols="4" class="py-0">
                <v-select
                    label="Bandeira"
                    outlined
                    dense
                    class="input-cinza"
                    v-model="value.bandeira"
                    :items="lista.bandeira"
                    :rules="regra.bandeira"
                    @change="
                    buscarPontasTematicas()
                    limpaFiliais()
                    "
                    :disabled="value.fnEditar || value.fnReplicar"
                    :menu-props="menuProps"
                    required
                ></v-select>
            </v-col>
   
        </v-row>            
        <v-row v-if="value.metodo_criacao !== 'MD'">             
            <v-col cols="4" class="py-0">
                <v-select
                    label="Tipo de acordo"
                    class="input-cinza"
                    outlined
                    dense
                    v-model="value.metodo_criacao"
                    :items="tiposAcordos"
                    :disabled="bloqueiaTipoAcordo"
                    :menu-props="menuProps"
                    @change="tipoAcordoChange"
                    required
                ></v-select>
            </v-col>
            <v-col cols="4" class="py-0">
                <v-autocomplete
                    label="Espaço"
                    class="input-cinza"
                    ref="espaco"
                    outlined
                    dense
                    v-model="id_espaco"
                    :items="filtroInputEspaco"
                    :rules="regra.espaco"
                    @change="
                        setInformacoesAdicionais($event)
                        limpaFiliais($event)
                    "
                    :disabled="bloqueiaEspacoAcordo"
                    :menu-props="menuProps"
                    required
                ></v-autocomplete>
            </v-col>
            <v-col cols="4" class="py-0" v-if="activeModelo">
                <v-select
                    label="Modelo Check-out"
                    class="input-cinza"
                    outlined
                    dense
                    v-model="value.modelo_ck"
                    :items="lista.modelo"
                    :rules="regra.modelo"
                    @change="limpaFiliais()"
                    :disabled="bloqueiaModeloCheckout"
                    :menu-props="menuProps"
                    required
                />
            </v-col>
            <v-col
                cols="2"
                class="py-0 d-flex align-top"
                v-if="activeFlagTeste"
            >
                <v-checkbox
                    v-model="value.flag_teste"
                    label="Acordo de teste"
                    class="my-0"
                    @change="limpaFiliais()"
                    :disabled="value.fnEditar || value.fnReplicar"
                />
                <div class="">
                    <InfoBox>
                        <p>
                            Se ativar essa opção, será possível selecionar as
                            lojas disponíveis para criar um o acordo de teste na
                            próxima etapa, caso contrário, por se tratar de um
                            espaço orgânico, as lojas já serão selecionadas
                            automaticamente, sem a opção de editá-las.
                        </p></InfoBox
                    >
                </div>
            </v-col>
        </v-row>            
        <v-row v-else>  
            <v-col cols="4" class="py-0">
                <v-select
                    label="Tipo de acordo"
                    class="input-cinza"
                    outlined
                    dense
                    v-model="value.metodo_criacao"
                    :items="tiposAcordos"
                    :disabled="bloqueiaTipoAcordo"
                    :menu-props="menuProps"
                    @change="tipoAcordoChange"
                    required
                ></v-select>
            </v-col>  
            <v-col cols="4" class="py-0">
                <v-autocomplete
                    label="Espaço Movel Dermo"
                    class="input-cinza"
                    outlined
                    multiple
                    dense
                    v-model="ids_espaco_dermo"
                    :items="lista.moveisDermo"
                    :rules="regra.espaco"
                    @change="
                        changed
                    "
                    :disabled="isDisabledEspacoMovelDermo"
                    :menu-props="menuProps"
                    required>
                    <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle">
                            <v-list-item-action>
                            <v-icon :color="lista.espaco.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                            <v-list-item-title>Selecione Todos</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                    </template>
                    <template v-slot:selection="{ item, index }">
                        <div
                            v-if="
                                ids_espaco_dermo.length === 1 &&
                                index === 0
                            "
                            style="
                                width: 70% !important;
                                white-space: nowrap !important;
                                text-overflow: ellipsis !important;
                                overflow: hidden;
                            "
                        >
                            {{ item.text }}
                        </div>
                        <span
                            v-if="
                                ids_espaco_dermo.length > 1 &&
                                index === 0
                            "
                            class="grey--text caption mr-1"
                            >{{
                                ids_espaco_dermo.length
                            }}
                            selecionados</span
                        >
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="4" class="py-0">
                <v-tooltip top :disabled="value.id_fornecedor > 0">
                    <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                            label="Marca"
                            class="input-cinza"
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :readonly="!value.id_fornecedor"
                            dense
                            :items="listaMarcas"
                            :loading="loadingMarcas"
                            v-model="value.marca"
                            :menu-props="menuProps"
                            :rules="regra.marca"
                            required
                            
                        ></v-autocomplete>
                    </template>
                    <span>Selecione o fornecedor primeiro</span>
                </v-tooltip>
            </v-col>

        </v-row>            
        <v-row>   

            <v-col cols="6" v-if="value.metodo_criacao == 'MD'" class="py-0">
            
                <v-data-table
                    :headers="listaHeader"
                    :items="value.moveisDermo" 
                    item-key="id_produto"
                    class="elevation-0 tabela"
                    hide-default-footer
                    disable-sort
                    
                >
                    <template v-slot:[`item.testeira`]="{ item }">
                        <v-text-field
                            :ripple="false"
                            dense
                            outlined
                            class="input-cinza"
                            v-model="item.testeira"
                            :rules="regra.testeira"
                            hide-details
                            :disabled="isDisabledEspacoMovelDermo"
                        ></v-text-field>
                    </template>
                </v-data-table>
            </v-col>    
            <v-col :cols="value.metodo_criacao !== 'MD' ? 12 : 6" class="py-0">
                <v-textarea
                    outlined
                    v-model="value.obs_departamento"
                    :disabled="isUsuarioMarcasProprias()"
                    class="input-cinza"
                    dense
                    rows="3"
                    label="Observação Departamento"
                ></v-textarea>
            
                <v-textarea
                    outlined
                    v-model="value.obs_contrato"
                    :disabled="isUsuarioMarcasProprias()"
                    class="input-cinza"
                    dense
                    rows="3"
                    label= "Observação do Contrato"
                ></v-textarea>
            </v-col>
        </v-row>

        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>

        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 6"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
    </v-form>
</template>

<script>
import smartId from "smart-id"
import useUsuario from "../../../hooks/useUsuario";
import SelectInput from "../../../components/SelectInput.vue";

export default {
    components: {
        SelectInput
    },
    inject: ["listaCampos"],
    props: ["value","usuarioTipo"],
    setup(){
        const { isUsuarioMarcasProprias } = useUsuario();
        return {
            isUsuarioMarcasProprias
        }
    },
    data() {
        return {
            listaHeader: [
                {
                    text: "Espaço",
                    value: "text",
                    align: "left",
                    class: "th-separador",
                    width: "235px",
                },
                {
                    text: "Informação testeira",
                    value: "testeira",
                    align: "left",
                }
            ],
            id_espaco: null,
            ids_espaco_dermo: [],
            mesesPeriodo: [],
            tiposAcordos: [
                {value:'PD',text:'Padrão'},
                {value:'RG',text:'Acordo por região'},
                {value:'MD',text:'Movel dermo'}
            ],
            acordo: {
                negociacao_comercial: 'SIM',
                mesInicial: null,
                mesFinal: null,
                id_espaco: null,
                id_fornecedor: null,
                fornecedor: null,
                bandeira: null,
                modelo_ck: null,
                flag_teste: false,
                obs_departamento: null,
                obs_contrato: null,
                visivel: null,
                planograma: null,
                comentario: null,
                fnEditar: false,
                fnLeitura: false,
                metodo_criacao: 'PD',
                regioesSelecionadas: [],
                assinatura: null,
                testeira: '',
                moveisDermo: [],
                produtos_por_cluster: false,
                espaco_macro: null,
                dataInicialSemana: null,
                dataFinalSemana: null
            },
            lista: {
                bandeira: [],
                espaco: [],
                espacoOrganicos: [],
                modelo: ["ANTIGO", "NOVO"],
            },
            id_produtoBusca: null,
            buscaProdutoFornecedor: null,
            isLoadingProduto: false,
            regra: {
                id_acordo_ecommerce: [
                    (v) => !!v || "O campo Id Ecommerce é obrigatório",
                ],
                mesInicial: [
                    (v) => this.value.isTelaSemana || !!v || "O campo período inicial é obrigatório",
                    (v) =>
                        this.value.isTelaSemana ||
                        (v && v >= this.mesAtual) ||
                        this.value.fnLeitura ||
                        "O período inicial deve ser igual ou posterior ao mês atual",
                ],
                mesFinal: [
                    (v) => this.value.isTelaSemana || !!v || "O campo período final é obrigatório",
                    (v) =>
                        this.value.isTelaSemana ||
                        (v && v >= this.value.mesInicial) ||
                        "O período final deve ser igual ou posterior ao período inicial",
                ],
                espaco: [(v) => !!v || "O campo espaço é obrigatório"],
                fornecedor: [(v) => !!v || "O campo fornecedor é obrigatório"],
                bandeira: [(v) => !!v || "O campo bandeira é obrigatório"],
                modelo: [
                    (v) =>
                        !!v ||
                        this.value.fnLeitura ||
                        //this.value.fnReplicar ||
                        "O campo modelo check-out é obrigatório",
                ],
                testeira: [
                    (v) => this.value.metodo_criacao == 'MD' && !!v || "O campo espaço é obrigatório"
                ],
                marca: [
                    (v) => this.value.metodo_criacao == 'MD' && !!v || "O campo espaço é obrigatório"
                ],
                dataInicialSemana: [
                    (v) => !this.value.isTelaSemana || !!v || "O campo data inicial é obrigatório",
                    (v) => this.validarPeriodoInicialSemana(v) || 'Data inválida'
                ],
                dataFinalSemana: [
                    (v) => !this.value.isTelaSemana || !!v || "O campo data final é obrigatório",
                    (v) => this.validarPeriodoFinalSemana(v) || 'A data final deve ser posterior à data inicial e no mesmo mês',
                    (v) => this.validarRangeDias(v) || 'O período deve ser de 7, 14, 21 ou 28 dias'
                ],

            telas_semanas: [
                (v) => !!v || "O campo semana é obrigatório",
            ],

            },
            semAcesso: false,
            loadingMarcas: false,
            listaMarcas: [],
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
                zIndex: 9999
            },
            alerta: false,
            alertaTexto: "",
            alertaColor: "error",
            alertaTimeout: 3000
        };
    },
    mounted() {
        this.getMesesPeriodo();
    },
    async created() {
        var lista = await this.listaCampos;
        this.lista.bandeira = lista.bandeira;
        this.lista.espaco = lista.espaco.map(item => {
            return {...item,testeira: ''}
        });
        this.lista.espaco = lista.espaco.filter(item => {
            var found = false
            for (let itemCubo of lista.cubosNaoPermitidosNovosAcordos) {
                if (item.id_espaco == itemCubo.id_espaco) found = true
            }
            return !found
        });
        this.lista.espacoOrganicos = lista.espaco.filter(item => item.organico);
        this.lista.moveisDermo =  lista.espaco.filter(item => item.espaco_macro == 'Móvel Dermo');
        // Remove móvel dermo da lista de espaços para acordo padrão
        // this.lista.espaco =  lista.espaco.filter(item => item.espaco_macro !== 'Móvel Dermo');
        this.lista.calendarioTelasSemanas = lista.calendarioTelasSemanas;
        this.buscarPontasTematicas()
        this.id_espaco = this.value.id_espaco
        if (this.usuarioTipo == 'cubo') {
            this.lista.espaco = 
            lista.espaco
                .filter(item => item.espaco_macro == 'Cubo' || item.espaco_macro == 'Marca própria')
                // .filter(item => item.apelido)
                .filter(item => {
                    if(item.apelido && item.apelido.toLowerCase().includes('inferior')){
                        return true
                    }
                    
                    if(
                                [
                                    'cubo 4 - ','cubo 5 - ','cubo 6 - ','cubo 7 - ','cubo 8 - ','cubo 9 - ','cubo 10 -',
                                    'cubo 11 -','cubo 12 -','cubo 13 -','cubo 14 -','cubo 15 -','cubo 16 -', 'cubo marca'
                                ].some(prefix => item.text.toLowerCase().startsWith(prefix))){
                        return true
                                }
                    return false
        });
            this.lista.espacoOrganicos = 
                this.lista.espacoOrganicos
                .filter(item => item.espaco_macro == 'Cubo' || item.espaco_macro == 'Marca própria')
                // .filter(item => item.apelido)
                .filter(item => {
                    if( item.apelido && item.apelido.toLowerCase().includes('inferior')){
                        return true
                    }
                    
                    if(
                                [
                                    'cubo 5 - ','cubo 6 - ','cubo 7 - ','cubo 8 - ','cubo 9 - ','cubo 10 -',
                                    'cubo 11 -','cubo 12 -','cubo 13 -','cubo 14 -','cubo 15 -','cubo 16 -', 'cubo marca'
                                ].some(prefix => item.text.toLowerCase().startsWith(prefix))){
                        return true
                                }
                    return false
        });
            this.lista.moveisDermo = [];
        }
        console.log('created',this.usuarioTipo)
    },
    computed: {
        isPreAcordoEdicao() {
            return this.value.preAcordo && this.value.fnEditar && !this.value.fnLeitura;
        },
        bloqueiaPeriodoAcordo() {
            return this.value.fnReplicar || this.value.isTelaSemana || (this.value.fnEditar && !this.isPreAcordoEdicao);
        },
        bloqueiaTipoAcordo() {
            return this.value.fnReplicar || this.value.isExposicao || this.value.isTelaSemana || (this.value.fnEditar && !this.isPreAcordoEdicao);
        },
        bloqueiaEspacoAcordo() {
            return this.value.fnReplicar || (this.value.fnEditar && !this.isPreAcordoEdicao);
        },
        bloqueiaModeloCheckout() {
            return this.bloqueiaEspacoAcordo && this.value.modelo_ck !== null;
        },
        codigoCheckoutPermitidos() {
            const id_espacos = [
                32,759,273,765,159,771,345,777,243,783,207,1519,789,1525,315,
                1531,795,1537,357,1543,801,1549,351,1555,807,1561,363,1567,
                813,1573,7722,195,1579,819,1585,267,1591,825,1597,225,1603,
                831,1609,231,1615,837,1621,129,1627,843,1633,44,1639,849,
                1645,237,855,249,861,255,867,261,873,1363,1369
            ]
            console.log('some',id_espacos.includes(this.id_espaco))
            return id_espacos.includes(this.id_espaco)
        },
        marcoTodosEspacos () {
            return this.ids_espaco_dermo.length === this.lista.moveisDermo.length
        },
        marcoAlgunsEspacos () {
            return this.ids_espaco_dermo.length > 0 && !this.marcoTodosEspacos
        },
        icon () {
            if (this.marcoTodosEspacos) return 'mdi-close-box'
            if (this.marcoAlgunsEspacos) return 'mdi-checkbox-blank-outline'
            return 'mdi-checkbox-blank-outline'
        },
        mesAtual() {
            return this.$moment().format("YYYY-MM");
        },
        activeModelo() {
            if (!this.value.fnEditar) this.clearVarAcordo("modelo_ck");

            let _espacoMacro =
                this.lista.espaco
                    .filter((e) => e.value == this.value.id_espaco)
                    .map((e) => e.espaco_macro)[0] || "";

            return _espacoMacro.toLowerCase() == "check-out";
        },
        dataMinima() {
            return this.$moment().format('YYYY-MM-DD')
        },
        filtroInputEspacoPre(){
            // Cubo Campanha - um quarto (somente_regiao) só pode ser usado no acordo por região
            const espacos = this.lista.espaco.filter(item => !item.somente_regiao)
            if (this.value.metodo_criacao == 'PD') {
                const idsEspacoTela = [19325722, 19322408, 19322401];
                if (this.value.isExposicao) return espacos.filter(item => item.espaco_macro === 'Materiais Leves' )
                if (this.value.isTelaSemana) return espacos.filter(item => idsEspacoTela.includes(item.id_espaco))

                // Oculta alguns espaços, porém deixa visivel se for edição ou replicação
                // os espaços são cubo 15 e cubo 16
                // Se for edição ou replicação, não aplica o filtro restritivo
                if (this.value.fnEditar || this.value.fnReplicar) {
                    return espacos.filter(item => item.espaco_macro !== 'Móvel Dermo' && !idsEspacoTela.includes(item.id_espaco));
                }

                // Aplica filtro restritivo apenas quando não for edição nem replicação
                return espacos.filter(item =>
                    item.espaco_macro !== 'Móvel Dermo' 
                    && !idsEspacoTela.includes(item.id_espaco) 
                    && !item.text.startsWith('Cubo 15')
                    && !item.text.startsWith('Cubo 16')
                );



            }
            if (this.value.metodo_criacao == 'RG') return this.lista.espacoOrganicos;
            return this.lista.espacoOrganicos.filter(item => !item.somente_regiao);
        },
        filtroInputEspaco(){
            console.log('filtroInputEspaco',this.fornecedorMarcaPropria)
            if(this.fornecedorMarcaPropria) {
                // remove espaço id: 105
                return this.filtroInputEspacoPre.filter(item => item.id_espaco !== 105)
            }
            // remove espaço id: 507
            return this.filtroInputEspacoPre.filter(item => item.id_espaco !== 507)
        },
        activeFlagTeste() {
            let _organico =
                this.lista.espaco
                    .filter((e) => e.value == this.value.id_espaco)
                    .map((e) => e.organico)[0] || 0;

            return _organico;
        },
        isDisabledEspacoMovelDermo() {
            const isEspacoDermo = this.value.espaco_macro === 'Móvel Dermo';
            return !isEspacoDermo && this.bloqueiaEspacoAcordo
        },
        dataFinalMaxima() {
            if (this.value.dataInicialSemana) {
                // Pega o último dia do mês da data inicial
                const dataInicial = this.$moment(this.value.dataInicialSemana);
                const ultimoDiaDoMes = dataInicial.clone().endOf('month');
                return ultimoDiaDoMes.format('YYYY-MM-DD');
            }
            return null;
        },
        diasPermitidosDataFinal() {
            if (!this.value.isTelaSemana || !this.value.dataInicialSemana) return null;
            
            // Para data final, permite apenas datas que resultem em períodos de 7, 14, 21 ou 28 dias
            return (date) => {
                const dataInicial = this.$moment(this.value.dataInicialSemana);
                const dataFinal = this.$moment(date);
                
                // Verifica se está no mesmo mês
                if (!dataInicial.isSame(dataFinal, 'month')) {
                    return false;
                }
                
                // Verifica se a data final é posterior à data inicial
                if (!dataFinal.isAfter(dataInicial)) {
                    return false;
                }
                
                // Calcula a diferença em dias (incluindo o dia inicial)
                const diffDias = dataFinal.diff(dataInicial, 'days') + 1;
                
                // Permite apenas múltiplos de 7 (7, 14, 21, 28)
                return diffDias > 0 && diffDias % 7 === 0;
            };
        },
        fornecedorSelecionado() {
            if (!this.value.id_fornecedor) return null;
            return this.lista?.produto?.find(item => item.id_fornecedor == this.value.id_fornecedor);
        },
        listaSemanas(){
            
            if(!this.value.mesInicial) return [];
            if(!this.lista.calendarioTelasSemanas) return [];

            return this.lista.calendarioTelasSemanas.filter(item => this.$moment(item.mes).format('YYYY-MM') == this.$moment(this.value.mesInicial).format('YYYY-MM'))
        },
        fornecedorMarcaPropria() {
            if(!this.fornecedorSelecionado) return null;
            console.log('fornecedorSelecionado',this.fornecedorSelecionado)
            return this.fornecedorSelecionado.fornecedor_marcas_proprias // == true;
        }
    },
    watch: {
        async buscaProdutoFornecedor(val) {
            if (!val) {
                this.id_produtoBusca = null;
                return;
            }

            if (val.length < 4) return;

            if (this.isLoadingProduto) return;

            this.isLoadingProduto = true;

            var data = { produto: val, negociacao_comercial: this.value.negociacao_comercial };

            var response = await this.$http().post("/acordo/buscaProdutos", {
                data: data,
            });

            this.lista.produto = response.data;

            this.isLoadingProduto = false;
        },
        id_produtoBusca(val) {
            var produto = this.lista.produto.find((e) => e.value == val);

            this.value.id_fornecedor = produto ? produto.id_fornecedor : null;
            this.value.fornecedor = produto ? produto.fornecedor : null;
        },
        'value.id_fornecedor': {
            handler(v) {
                this.getMarcas()
            },
        },
        'value.id_acordo_ecommerce': {
            handler(v) {
                console.log("v", v)
            },
        },
        id_espaco: {
            handler(v) {
                this.confereEspacoPeriodo();
            },
        },
        'value.dataInicialSemana': {
            handler(novaDataInicial, dataInicialAnterior) {
                if (novaDataInicial) {
                    // Define automaticamente o mês inicial baseado na data selecionada
                    const mesDataInicial = this.$moment(novaDataInicial).format('YYYY-MM');
                    this.value.mesInicial = mesDataInicial;
                }
                
                // Limpa a data final sempre que a data inicial mudar
                if (novaDataInicial && dataInicialAnterior && novaDataInicial !== dataInicialAnterior) {
                    this.value.dataFinalSemana = null;
                }
            },
        },
        'value.dataFinalSemana': {
            handler(novaDataFinal) {
                if (novaDataFinal) {
                    // Define automaticamente o mês final baseado na data selecionada
                    const mesDataFinal = this.$moment(novaDataFinal).format('YYYY-MM');
                    this.value.mesFinal = mesDataFinal;
                    this.limpaFiliais();
                }
            },
        },
    },
    methods: {
        changed () {
            console.log('changed',this.ids_espaco_dermo)
            if (!this.value.moveisDermo) this.value.moveisDermo = []
            for (let espaco of this.ids_espaco_dermo) {
                var espacoChecado = _.find(this.value.moveisDermo,{id_espaco: espaco})
                console.log(espaco,espacoChecado,this.lista.moveisDermo)
                if (espacoChecado == undefined) {
                    console.log((_.find(this.lista.moveisDermo,{id_espaco: espaco})))
                    this.value.moveisDermo.push(_.find(this.lista.moveisDermo,{id_espaco: espaco}))
                    
                }
            }
            this.value.moveisDermo = this.value.moveisDermo.filter(item => {
                return this.ids_espaco_dermo.includes(item.id_espaco)
            })
            if (this.value.moveisDermo.length > 0) { 
                this.setInformacoesAdicionais(this.value.moveisDermo[0].id_espaco) 
            }
            console.log(this.value.moveisDermo)
        },
        toggle () {
            this.$nextTick(() => { 
                var text = "" 
                if (this.marcoTodosEspacos) {
                    this.ids_espaco_dermo = []
                    text = "Nenhum espaço"
                } else {
                    this.ids_espaco_dermo = this.lista.moveisDermo.map(item => {
                        return item.value
                    })
                    text = "Todos espaços"
                }
                
                
            })
        },
        showFlagTeste() {
            const text = `
				Se ativar essa opção, será possível selecionar as lojas disponíveis para criar um o acordo\n
				de teste na próxima etapa, caso contrário, por se tratar de um espaço orgânico,\n
				as lojas já serão selecionadas automaticamente,
				sem a opção de editá-las.
			`;

            this.$dialog.confirm({
                text: text,
                title: "Ajuda",
                actions: [{ text: "OK", color: "teal" }],
                color: "teal lighten-2",
            });
        },
        clearVarAcordo(key) {
            this.acordo[key] = null;
        },
        setAcordo(acordo) {
            this.acordo = { ...acordo, value: acordo.id_espaco };
            
            this.id_espaco = this.acordo.id_espaco
            if (this.acordo.fnEditar || this.acordo.fnLeitura || this.acordo.fnReplicar)  {
                console.log('modo')
                if (this.acordo.metodo_criacao == 'MD') {
                    console.log('ajuste')
                    this.ids_espaco_dermo = this.acordo.espacosLote
                    console.log(this.ids_espaco_dermo)
                    if (!this.acordo.moveisDermo) this.acordo.moveisDermo = []
                    for (let espaco of this.ids_espaco_dermo) {
                        var espacoChecado = _.find(this.acordo.moveisDermo,{id_espaco: espaco})
                        console.log(espaco,espacoChecado,this.lista.moveisDermo)
                        if (espacoChecado == undefined) {
                            console.log((_.find(this.lista.moveisDermo,{id_espaco: espaco})))
                            this.acordo.moveisDermo.push(_.find(this.lista.moveisDermo,{id_espaco: espaco}))
                            
                        }
                    }
                    this.acordo.moveisDermo = this.acordo.moveisDermo.filter(item => {
                        return this.ids_espaco_dermo.includes(item.id_espaco)
                    })
                    if (this.acordo.moveisDermo.length > 0) { 
                        this.setInformacoesAdicionais(this.acordo.moveisDermo[0].id_espaco) 
                    }
                    console.log('linhas moveis dermo',this.acordo.moveisDermo)
                    // this.acordo.moveisDermo[0].testeira = acordo.testeira
                  for (const item of this.acordo.moveisDermo) {
                    const testeira = this.acordo.testeirasLote.find(e => e.id_espaco == item.id_espaco)
                    console.log("Testa",testeira)
                    item.testeira = testeira.testeira;
                  }
                }
                // console.log('teste')
                // this.changed()
            }
        },
        setSemAcesso(semAcesso) {
            this.semAcesso = semAcesso;
        },
        setTipoAcordoPD(){
            this.value.metodo_criacao = 'PD';
            this.limpaEspaco();
            this.limpaCadastro();
        },
        tipoAcordoChange() {
            this.limpaDesconto();
            this.limpaFiliais();
            this.value.modelo_ck = null;
            this.value.flag_teste = false;
            this.value.moveisDermo = [];
            this.ids_espaco_dermo = [];
            this.value.marca = null;
            this.limpaEspaco();
        },
        limpaCadastro() {
            this.id_produtoBusca = null;
            this.buscaProdutoFornecedor = null;
            this.fornecedor = null
            this.lista.produto = [];
            this.acordo = {
                mesInicial: null,
                mesFinal: null,
                id_espaco: null,
                id_fornecedor: null,
                modelo_ck: null,
                flag_teste: false,
                fornecedor: null,
                bandeira: null,
                obs_departamento: null,
                obs_contrato: null,
                visivel: null,
                planograma: null,
                comentario: null,
                fnEditar: false,
                metodo_criacao: 'PD',
                espaco_macro: null,
                dataInicialSemana: null,
                dataFinalSemana: null,
                telas_semanas: []
            };
            this.id_espaco = null
            this.ids_espaco_dermo = null
            this.lista.moveisDermo = this.lista.moveisDermo.map(item => {
                return {...item,testeira: ''}
            })
        },
        async buscarPontasTematicas() {
            console.log('ponta tematica')
			if ((!this.value.mesInicial) || (!this.value.mesFinal)) {
				return;
			}

			if (this.isLoadingPontasTematicas) return;

			this.isLoadingPontasTematicas = true;

            let pontasTematicas = []
            if (this.value.bandeira) {
                var data = { 
                    mesInicial: this.value.mesInicial + '-01',
                    mesFinal: this.value.mesFinal + '-01',
                    bandeira: this.value.bandeira
                };

                var response = await this.$http().post("/pontatematica/pontasTematicasNoPeriodo", {
                    data: data,
                });

                // O interceptor do $http nao rejeita em erro: devolve error.response com
                // erro = true. Sem esta guarda, response.data.lista fica undefined e o
                // .map abaixo estoura, quebrando o cadastro de acordo.
                if (!response.erro && response.data && Array.isArray(response.data.lista)) {
                    pontasTematicas = response.data.lista
                }
            } else {
                console.log('vo nao')
            }	

			// Le lista.espaco DEPOIS do await, nao antes: created() chama esta funcao sem
			// await e pode reduzir lista.espaco em seguida (filtro de usuario cubo). Com o
			// snapshot antigo, a atribuicao desfazia esse filtro.
			let espaco = this.lista.espaco.filter(item => !item.ponta_tematica)

			this.lista.espaco = [ ...espaco, ...pontasTematicas.map(item => {
				var id = smartId.make()
				return {...item, value: id }
			})]

			this.isLoadingPontasTematicas = false;
		},
		setInformacoesAdicionais(event) {
			const espacoSeleciondo = this.lista.espaco.filter(item => (item.value == event))
            // console.log(espacoSeleciondo)
            this.value.espaco_macro = espacoSeleciondo[0].espaco_macro
            this.value.espaco = espacoSeleciondo[0].text
			this.value.id_espaco = espacoSeleciondo[0].id_espaco
			this.value.id_espaco_tematico = espacoSeleciondo[0].id_espaco_tematico
			this.value.ponta_tematica = espacoSeleciondo[0].ponta_tematica
			this.value.prateleira_nome = espacoSeleciondo[0].ponta_tematica ? espacoSeleciondo[0].text : null
			this.value.prateleira = espacoSeleciondo[0].prateleira
			this.value.tema = espacoSeleciondo[0].tema
            this.value.id_ponta_tematica = espacoSeleciondo[0].id_ponta_tematica
            // console.log(espacoSeleciondo[0].mecanismo_preco_id)
            this.value.mecanismo_preco_id = espacoSeleciondo[0].mecanismo_preco_id
            this.value.produtos_por_cluster = espacoSeleciondo[0].espaco_macro == 'Cubo' ||  espacoSeleciondo[0].espaco_macro == 'Fila Única'
            // console.log('this.value.produtos_por_cluster',this.value.produtos_por_cluster)
            this.value.espaco_macro = espacoSeleciondo[0].espaco_macro
            // console.log('setInformacoesAdicionais',)
            // console.log(JSON.stringify(espacoSeleciondo[0],null,2))
		},
        limpaEspaco(){
            this.value.espaco_macro = null;
            this.value.id_espaco = null;
            this.value.id_espaco_tematico = null;
            this.value.ponta_tematica = null;
            this.value.prateleira_nome = null;
            this.value.prateleira = null;
            this.value.tema = null;
            this.value.id_ponta_tematica = null;
            this.value.mecanismo_preco_id = null;
            this.value.produtos_por_cluster = null;
            this.value.espaco_macro = null;
            this.id_espaco = null;
            if (this.$refs.espaco) {
                this.$refs.espaco.reset();
            }
        },
        limpaFiliais() {
            this.$emit("limpaFiliais");
        },
        limpaProdutos() {
            this.$emit("limpaProdutos");
        },
        limpaDesconto() {
            this.$emit("limpaDescontos");
        },
        validate() {
            return this.$refs.form.validate();
        },
        negociacaoChange() {
            this.limpaDesconto();
            this.limpaProdutos();
            this.limpaCadastro()
        },
        exposicaoChange() {
            this.limpaDesconto();
            this.limpaProdutos();
            this.limpaCadastro();
            this.setTipoAcordoPD()
        },
        telaSemanaChange() {
            this.limpaDesconto();
            this.limpaProdutos();
            this.limpaCadastro();
            this.setTipoAcordoPD()
            // temos que setar periodo final igual ao periodo inicial
            this.value.mesFinal = this.value.mesInicial;
        },
        produtoChange() {
            this.limpaDesconto();
            this.limpaProdutos();
        },
        resetValidation() {
            try {
                this.$refs.form.resetValidation();
            } catch (error) {
                //console.log(error)
            }
        },

        periodoInicialChange(valor) {
            this.buscarPontasTematicas()
            this.limpaDesconto();
            this.limpaFiliais();
            if (this.value.mesFinal < valor) {
                this.value.mesFinal = valor;
            }
            this.$nextTick(() => {
                this.getMesesPeriodo();
                this.confereEspacoPeriodo();
            })
        },
        periodoFinalChange(valor) {
            console.log('periodo final')
            this.buscarPontasTematicas()
            this.limpaDesconto();
            this.limpaFiliais();
            if (this.value.mesInicial > valor) {
                this.value.mesInicial = valor;
            }
            this.$nextTick(() => {
                this.getMesesPeriodo();
                this.confereEspacoPeriodo();
            })

        },
        firstLetterUppercase(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        getMesesPeriodo(){
            if ((!this.value.mesInicial) || (!this.value.mesFinal)) {
				return;
			}
            const inicio = this.$moment(this.value.mesInicial);
            const fim = this.$moment(this.value.mesFinal);

            let meses = [];
            let dataAtual = inicio.clone(); 

            while (dataAtual.isSameOrBefore(fim, 'month')) {
                meses.push(this.firstLetterUppercase(dataAtual.format('MMM')) + '/' + dataAtual.format('YY')); 
                dataAtual.add(1, 'month'); 
            }
            console.log('caiu aqui', meses)
            this.mesesPeriodo = meses;
        },
        confereEspacoPeriodo(){
            const espacosNaoPermitidos = [105];

            // if (espacosNaoPermitidos.includes(this.value.id_espaco) ||espacosNaoPermitidos.includes(this.id_espaco) ) {
            //     const anoAtual = this.$moment().year();
            //     const proximoAno = anoAtual + 1;
            //     const anoMesInicial = this.$moment(this.value.mesInicial).year();
            //     const anoMesFinal = this.$moment(this.value.mesFinal).year();

            //     if (anoMesInicial === proximoAno || anoMesFinal === proximoAno) {
            //         this.alerta = true;
            //         this.alertaColor = "error";
            //         this.alertaTimeout = 10000;
            //         const nomeEspaco = this.lista.espaco.find(item => item.id_espaco == this.value.id_espaco).text
            //         this.alertaTexto = `O Espaço ${nomeEspaco} não pode ser utilizado para o ano de ${proximoAno}.`;

            //         this.limpaEspaco()
            //     }
            // }
            
        },
        confiraTesteira(value) {
            var status = true
            if (this.value.moveisDermo.length > 0) {
                for (var item of this.value.moveisDermo) {
                    console.log(item)
                    if (status) {
                        if (!item.testeira || item.testeira.length == 0) {
                            status = false
                        }
                    }
                }
            } else {
                status = false
            }
            return status
        },
        validarPeriodoInicialSemana(v) {
            if (this.value.dataFinalSemana) {
                if (this.$moment(this.value.dataInicialSemana).isSameOrBefore(
                    this.value.dataFinalSemana
                )) {
                    return true
                } else {
                    return false
                }
            }
            return true
        },
        validarPeriodoFinalSemana(v) {
            if (this.value.dataInicialSemana) {
                const dataInicial = this.$moment(this.value.dataInicialSemana);
                const dataFinal = this.$moment(this.value.dataFinalSemana);
                
                // Verifica se a data final é posterior ou igual à data inicial
                if (!dataFinal.isSameOrAfter(dataInicial)) {
                    return false;
                }
                
                // Verifica se as datas estão no mesmo mês
                if (!dataInicial.isSame(dataFinal, 'month')) {
                    return false;
                }
                
                return true;
            }
            return true;
        },
        validarRangeDias(v) {
            if (!this.value.isTelaSemana) return true;
            
            if (this.value.dataInicialSemana && this.value.dataFinalSemana) {
                const dataInicial = this.$moment(this.value.dataInicialSemana);
                const dataFinal = this.$moment(this.value.dataFinalSemana);
                
                // Calcula a diferença em dias (incluindo o dia inicial)
                const diffDias = dataFinal.diff(dataInicial, 'days') + 1;
                
                // Verifica se é múltiplo de 7 (7, 14, 21, 28, etc.)
                return diffDias > 0 && diffDias % 7 === 0;
            }
            return true;
        },
        async getMarcas() {
            if (!this.value.id_fornecedor) return

            this.loadingMarcas = true
            const response = await this.$http().get(
                `/planejamentoEcommerce/listaMarcas/${this.value.id_fornecedor}`
            )

            if (
                response.status == 200 &&
                response.data.marcas &&
                response.data.marcas.length > 0
            ) {
                this.listaMarcas = response.data.marcas.map((item) =>item.text);
            }
            this.loadingMarcas = false
        },
    },
};
</script>
